import { Switch } from 'react-router-dom';
import PrivateRoute from '@/routes/PrivateRoute';
import AdminCompanyListPage from '@/components/pages/admin/AdminCompanyListPage';
import { Redirect } from 'react-router';

const AdminRoute = () => {
  return (
    <Switch>
      <PrivateRoute minRole="ADMIN" path="/admin/company" component={AdminCompanyListPage} />
      <Redirect path="/admin" to="/admin/company" />
    </Switch>
  );
};

export default AdminRoute;
